import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CardComp from "../components/CardComp";
import CardTes from "../components/CardTes";
import ftImage from "../assets/images/ft.jpg";
import { motion } from "framer-motion";

// --- DATA ---
const projectData = [
  {
    title: "FinanceFlow",
    description: "A comprehensive financial management platform serving 50,000+ users.",
    projectImage: ftImage,
    year: "2025",
    techStack: ["React", "Node.js", "PostgreSQL"],
    stats: { users: "500K+ Users", uptime: "99.9% Uptime", revenue: "$2M Revenue" },
    caseStudyLink: "#",
  },
  {
    title: "EcoSense AI",
    description: "AI-powered environmental monitoring platform.",
    projectImage: ftImage,
    year: "2024",
    techStack: ["Python", "TensorFlow", "React Native"],
    stats: { users: "10K+ Sensors", uptime: "99.99% Uptime", revenue: "$1.5M Revenue" },
    caseStudyLink: "#",
  },
  {
    title: "HealthHub Pro",
    description: "HIPAA-compliant healthcare management system.",
    projectImage: ftImage,
    year: "2023",
    techStack: ["Next.js", "TypeScript", "Prisma"],
    stats: { users: "200+ Hospitals", uptime: "99.8% Uptime", revenue: "$3.2M Revenue" },
    caseStudyLink: "#",
  },
];

const testimonialsData = [
  {
    quote: "They exceeded expectations and helped us scale massively.",
    name: "Sarah Johnson",
    title: "CEO, TechStart",
    avatarImage: ftImage,
    rating: 5,
  },
  {
    quote: "A true engineering partner, not just a vendor.",
    name: "Client A",
    title: "CTO, Company X",
    avatarImage: ftImage,
    rating: 5,
  },
];

const duplicatedProjectData = [...projectData, ...projectData, ...projectData];
const duplicatedTestimonialsData = [...testimonialsData, ...testimonialsData, ...testimonialsData];

export default function Services() {
  const neonGradientText = {
    background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  const carouselStyle = `
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(calc(-320px * 3)); }
    }
    .animate-infinite-scroll {
      animation: scroll 30s linear infinite;
    }
  `;

  return (
    <div className="min-h-screen bg-[#0B0E11] text-white flex flex-col overflow-hidden">
      <style>{carouselStyle}</style>
      <Navbar />

      <div className="flex-1 px-4 md:px-20 py-16 space-y-32">

        {/* ===== FEATURED WORK SECTION ===== */}
        <section className="relative min-h-[60vh] flex flex-col justify-center">

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center lg:text-left lg:pl-20"
          >
            <h2 className="text-4xl md:text-5xl font-extrabold mb-4 uppercase">
              FEATURED <span style={neonGradientText}>WORK</span>
            </h2>
            <div className="w-[70px] h-[3px] rounded-full bg-gradient-to-r from-[#00F5A0] to-[#00CFFF] mx-auto lg:mx-0 mb-6" />
            <p className="text-white/50 max-w-2xl mx-auto lg:mx-0 text-lg font-light">
              Every project reflects our obsession with quality and performance.
            </p>
          </motion.div>

          {/* Carousel */}
          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
            viewport={{ once: true }}
            className="mt-16 overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]"
          >
            <div className="flex space-x-8 animate-infinite-scroll w-max p-4">
              {duplicatedProjectData.map((project, index) => (
                <div key={index} className="w-80 flex-shrink-0">
                  <CardComp {...project} />
                </div>
              ))}
            </div>
          </motion.div>
        </section>


        {/* ===== TESTIMONIALS SECTION ===== */}
        <section className="relative min-h-[60vh] flex flex-col justify-center">


          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center lg:text-left lg:pl-20"
          >
            <h2 className="text-4xl md:text-5xl font-extrabold mb-4 uppercase">
              CLIENT <span style={neonGradientText}>FEEDBACK</span>
            </h2>
            <div className="w-[70px] h-[3px] rounded-full bg-gradient-to-r from-[#00F5A0] to-[#00CFFF] mx-auto lg:mx-0 mb-6" />
            <p className="text-white/50 max-w-2xl mx-auto lg:mx-0 text-lg font-light">
              Long-term partnerships built on trust and measurable results.
            </p>
          </motion.div>

          {/* Carousel */}
          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
            viewport={{ once: true }}
            className="mt-16 overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]"
          >
            <div className="flex space-x-8 animate-infinite-scroll w-max p-4">
              {duplicatedTestimonialsData.map((t, index) => (
                <div key={index} className="w-80 h-96 flex-shrink-0">
                  <CardTes {...t} />
                </div>
              ))}
            </div>
          </motion.div>
        </section>

      </div>

      <Footer />
    </div>
  );
}